import axios from '@/axios';

const RESOURCE_NAME = '/admin/ai-chat-logs';

export default {
    getConversationsList(data) {
        return axios.post(`${RESOURCE_NAME}/get-conversations-list`, data)
    },

    getMessages(id) {
        return axios.get(`${RESOURCE_NAME}/get-messages?id=${id}`)
    },
}
